import { useState, useEffect } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';

export default function HomeLayout({ children }) {
  const [phoneNumber, setPhoneNumber] = useState("6621940563");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // La misma lógica de distribución de carga 75/25
    const random = Math.random();
    if (random < 0.75) {
      setPhoneNumber("6621940563");
    } else {
      setPhoneNumber("6221001003");
    }
  }, []);

  // Función que arma el mensaje y manda al usuario a WhatsApp según la opción
  const handleWAClick = (opcion) => {
    let mensaje = "";
    
    if (opcion === 'comprar') {
      mensaje = "Hola seminuevos, estoy en el sitio web y busco información para *Comprar un auto*.";
    } else if (opcion === 'anunciar') {
      mensaje = "Hola seminuevos, me interesa saber cómo *Anunciar mi auto* en su plataforma.";
    } else if (opcion === 'general') {
      mensaje = "Hola seminuevos, tengo una *duda general* navegando por su página:";
    }

    // Codificamos el mensaje para que la URL no se rompa con los espacios
    const url = `https://wa.me/52${phoneNumber}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
    setIsOpen(false); // Cierra el menú después de hacer clic
  };

  return (
    <>
      <div className="px-4 md:pl-24 lg:pl-32 2xl:pl-72 flex flex-col gap-2">
        {children}
      </div>

      {/* 🟢 WIDGET FLOTANTE DE WHATSAPP 🟢 */}
      <div className="fixed bottom-6 right-6 z-[9999] flex flex-col items-end">
        
        {/* EL MENÚ DESPLEGABLE (Se muestra solo si isOpen es true) */}
        {isOpen && (
          <div className="mb-4 w-64 md:w-72 rounded-xl bg-white p-5 shadow-2xl border border-gray-200 transition-all duration-300">
            <div className="mb-3 flex items-center justify-between">
              <h3 className="font-extrabold text-sm text-gray-800">¿En qué te podemos ayudar?</h3>
              <button 
                onClick={() => setIsOpen(false)} 
                className="text-gray-400 hover:text-red-500 transition-colors"
                aria-label="Cerrar menú"
              >
                <FaTimes />
              </button>
            </div>
            
            <div className="flex flex-col gap-2 mt-4">
              <button 
                onClick={() => handleWAClick('comprar')} 
                className="w-full rounded-lg bg-gray-50 border border-gray-100 px-4 py-3 text-left text-sm font-semibold text-gray-700 hover:bg-yellow-50 hover:border-yellow-300 hover:text-yellow-700 transition-all"
              >
                🚗 Busco comprar un auto
              </button>
              <button 
                onClick={() => handleWAClick('anunciar')} 
                className="w-full rounded-lg bg-gray-50 border border-gray-100 px-4 py-3 text-left text-sm font-semibold text-gray-700 hover:bg-yellow-50 hover:border-yellow-300 hover:text-yellow-700 transition-all"
              >
                📢 Quiero anunciar mi auto
              </button>
              <button 
                onClick={() => handleWAClick('general')} 
                className="w-full rounded-lg bg-gray-50 border border-gray-100 px-4 py-3 text-left text-sm font-semibold text-gray-700 hover:bg-yellow-50 hover:border-yellow-300 hover:text-yellow-700 transition-all"
              >
                💬 Otra duda / Ayuda general
              </button>
            </div>
          </div>
        )}

        {/* BOTÓN REDONDO PRINCIPAL */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`flex h-16 w-16 items-center justify-center rounded-full text-white shadow-2xl transition-all duration-300 active:scale-95 ${isOpen ? 'bg-gray-800 hover:bg-gray-700' : 'bg-[#25D366] hover:bg-[#20ba5a] hover:scale-110'}`}
          aria-label="Abrir opciones de contacto"
        >
          {isOpen ? <FaTimes className="h-7 w-7" /> : <FaWhatsapp className="h-9 w-9" />}
        </button>
      </div>
    </>
  );
}